import { validateDateRange } from "shared/lib/date/validateDateRange";

const isNullOrUndefined = (value) => {
    return value === null || value === undefined;
}
const isString = (value) => typeof value === "string";
const isDate = (value) => value instanceof Date;
const isLocalDateTimeFormat = (dateString) => {
    // Define a regular expression pattern for LocalDateTime format
    const pattern1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
    const pattern2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

    // Test if the dateString matches the pattern
    return pattern1.test(dateString) || pattern2.test(dateString);
};

const converLocalDateTimetToDate = (localTimeString) => {
    // Construct a Date object from the local time string
    const date = new Date(localTimeString);

    // Return the Date object
    return date;
};
// suppose date is in yyyy-mm-dd format.
const stringFormatToDatetime = (dateString) => {
    const parts = dateString.split('-');
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; // Months in JavaScript are zero-indexed
    const day = parseInt(parts[2]);

    const date = new Date(year, month, day);
    return date;
}
const compareTwoDate = (dateA, dateB) => {

    if (isString(dateA)) {
        dateA = isLocalDateTimeFormat(dateA) ? converLocalDateTimetToDate(dateA) : stringFormatToDatetime(dateA);
    }
    if (isString(dateB)) {
        dateB = isLocalDateTimeFormat(dateB) ? converLocalDateTimetToDate(dateB) : stringFormatToDatetime(dateB);
    }

    if (!isDate(dateA) || !isDate(dateB)) {
        throw new Error("Both dateA and dateB should be instances of Date");
    }

    return dateA - dateB;
}
const formatFileSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};
function isToday(dateString) {
    
    var inputDate;
    if (isString(dateString)) {
        inputDate = isLocalDateTimeFormat(dateString) ? converLocalDateTimetToDate(dateString) : stringFormatToDatetime(dateString);
    }
    const today = new Date();

    return (
      inputDate.getDate() === today.getDate() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getFullYear() === today.getFullYear()
    );
  }
function validateChoosenDate(from, to){
    return validateDateRange(from, to).isValid;
}
const getTimeFromToday = (timePeriodFilter) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set time to midnight

    let endDate = new Date(today);

    switch (timePeriodFilter.state) {
        case 1: // 1주일
            endDate.setDate(today.getDate() - timePeriodFilter.duration);
            break;
        case 2: // 1개월
            endDate.setMonth(today.getMonth() - timePeriodFilter.duration);
            break;
        case 3: // 3개월
            endDate.setMonth(today.getMonth() - timePeriodFilter.duration);
            break;
        case 4: // 6개월
            endDate.setMonth(today.getMonth() - timePeriodFilter.duration);
            break;
        case 5: // 1년
            endDate.setFullYear(today.getFullYear() - timePeriodFilter.duration);
            break;
        default: // 오늘 (0)
            break;
    }

    return endDate;
};
export { compareTwoDate, converLocalDateTimetToDate, formatFileSize,getTimeFromToday, isDate, isLocalDateTimeFormat, isNullOrUndefined, isString, isToday, stringFormatToDatetime, validateChoosenDate };
